import React from 'react';
import Logo from '../../components/common/Logo/Logo';
import styles from './Fup.module.css';

const FupThankYou: React.FC = () => (
  <div className={styles.page}>
    <div className={styles.shell}>
      <div className={styles.header}>
        <Logo />
      </div>

      <section className={styles.panelCard}>
        <div className={styles.thankYouCard}>
          <span className={`material-symbols-outlined ${styles.thankYouIcon}`} aria-hidden="true">
            check_circle
          </span>
          <h1 className={styles.title}>Obrigada pelo seu retorno!</h1>
          <p className={styles.description}>
            Seu FUP já foi registrado. Não é necessário enviar novamente.
          </p>
        </div>
      </section>
    </div>
  </div>
);

export default FupThankYou;
